import { ContentStateProperty } from '../../../@types/types'
import { ScreenName } from '../../../services/domain/wizardScreens'
import { FormStateFeatureState } from '../../../@types/state-types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState: FormStateFeatureState = {
  submitCount: 0,
  touched: {},
  scrolled: {},
  touchedScreen: {},
  collapsedScreens: {
    objectDetails: true,
    webViewAmenities: true,
  },
}
const formStateFeatureSlice = createSlice({
  name: 'formStateFeature',
  initialState,
  reducers: {
    increaseSubmit(state) {
      state.submitCount = state.submitCount + 1
    },
    setScrolled(state, action: PayloadAction<{ screen: ScreenName }>) {
      const { screen } = action.payload
      state.scrolled = { ...state.scrolled, [screen]: true }
    },
    setTouched(state, action: PayloadAction<{ property: ContentStateProperty; screen?: ScreenName }>) {
      const { property, screen } = action.payload
      state.touched = { ...state.touched, [property]: true }
      state.touchedScreen = {
        ...state.touchedScreen,
        ...(screen && { [screen]: true }),
      }
    },
    resetTouched(state, action: PayloadAction<{ properties: ContentStateProperty[]; screens: ScreenName[] }>) {
      const { properties, screens } = action.payload
      state.touched = {
        ...initialState.touched,
        ...Object.fromEntries(properties.map((property) => [property, false])),
      }
      state.touchedScreen = {
        ...initialState.touchedScreen,
        ...Object.fromEntries(screens.map((property) => [property, false])),
      }
    },
    toggleScreenCollapse(state, action: PayloadAction<{ screens: ScreenName[] }>) {
      const { screens } = action.payload
      const newCollapsedScreens = { ...state.collapsedScreens }
      screens.forEach((screen) => {
        newCollapsedScreens[screen] = !newCollapsedScreens[screen]
      })

      state.collapsedScreens = newCollapsedScreens
    },
  },
})
export const { increaseSubmit, resetTouched, setScrolled, setTouched, toggleScreenCollapse } =
  formStateFeatureSlice.actions
export default formStateFeatureSlice.reducer
